import Background from "assets/img/modelve/bg-simple-lines.png";
import Modelve from "assets/img/modelve/modelve-white.svg";
import { Spinner } from "@modelve/ui";

const Landing = () => (
  <div
    className="h-screen w-screen bg-secondary-dark relative"
    style={{
      backgroundImage: `url(${Background})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 animate-pulse">
      <div className="text-white flex flex-col gap-4">
        <img src={Modelve} alt="Modelve logo" className="w-64 h-auto" />
        <div className="flex flex-row gap-2 items-center">
          <Spinner size="sm" />
          <div>Welcome to Modelve</div>
        </div>
      </div>
    </div>
  </div>
);

export default Landing;
